export default __webpack_public_path__ + "resources/icons/n600-4509.png";